export default __webpack_public_path__ + "static/media/NC_2043x119.bcea2486.png";